/**
 * 브라우저 캐시에 남은 다른 계정(KOROT, 공용 PC 의 이전 사용자 등)을 비우고 새로고침한다.
 * 새로고침하면 loginRequest 의 prompt: "select_account" 로 계정 선택 화면이 다시 뜬다.
 */
export function switchAccount(): void {
  window.localStorage.clear();
  window.location.reload();
}
